<template>
  <div class="max-w-6xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 items-center">
      <div v-for="(item, index) in logos" :key="index" class="flex justify-center">
        <a :href="item.url" target="_blank" rel="noopener noreferrer" class="transition-transform duration-300 ease-in-out hover:scale-110">
          <img :src="item.logo_url" :alt="item.alt_text" class="max-h-20 object-contain">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridTemplate",
  props: {
    logos: {
      type: Array,
      required: true,
    },
  },
};
</script>
